/**
 * 장면의 타입. 지금까지는 일반(normal)/카톡창(kakaotalk)의 2개
 */
export enum SceneType {
  Normal = 'normal',
  Kakaotalk = 'kakaotalk',
}
